import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 39.8 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 20C-.2 9.1 8.6.1 19.5 0h.4c10.9-.1 19.8 8.7 19.9 19.6v.4c.1 10.9-8.6 19.8-19.4 20h-.5C9 40.1.1 31.4 0 20.5V20Zm1.9.1c-.1 9.9 7.7 18 17.6 18.2h.4c9.9.1 18-7.8 18.1-17.7v-.4c.2-9.9-7.8-18.1-17.7-18.2h-.4C10 1.9 1.9 9.9 1.8 19.9c.1-.1.1 0 .1.2Zm2.3-6h9.6v1.7l-1.9.5 6.2 4s-3.3-2.9-2.2-5.1c.5-.8 1.4-1.2 2.4-1.1h17.5l-10.5 8.3-1.2-1.2 5.1-4.9h-9.7c-.1 0-.6 0-.7.3-.7 1.5 5 7.2 10.6 11l2.4 1.6V32L4.2 14.1Z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "DE-logo"}) } }